import css from 'styled-jsx/css';

export default css`
.world-cup-banner {
  &--desktop {
    display: none;
    & > picture > img {
      border-radius: 16px;
    }
  }
  &--mobile {
    display: block;
    & > picture > img {
      border-radius: 16px;
    }
  }
}
@media screen and (min-width: 768px) {
  .world-cup-banner {
    &--desktop {
      display: block;
    }
    &--mobile {
      display: none;
    }
  }
}

:global(.world-cup-banner--image) {
  border-radius: 16px;
}
`;
